import { Query } from "@repo/rq-api-public";

export const useCampaignVisitMutation = () => {
  return Query.useCampaignsVisitPOSTMutation();
};

export const usePricingCampaignValidationMutation = () => {
  return Query.usePricingsGuidCampaignValidationPOSTMutationWithParameters();
};

export const useCampaignValidationByCustomerEmailMutation = () => {
  return Query.usePricingsGuidCampaignValidationByCustomerEmailPOSTMutationWithParameters();
};
